<template lang="pug">
.IntroMap(ref="cont")
  .IntroMap__scale-lfo
    img.IntroMap__img(ref="img", :src="introMapSrc")
    //- span(ref="grav")
</template>
<script>
import { onScroll, $el as $scroll } from 'services/scroll';
import { /*lerpRange, clamp,*/ invlerp } from 'utils';
import introMapSrc from 'assets/imgs/intro.svg';

function exp (v, vv) {
  const k = v < 0 ? -1 : 1;
  return (v * k)**vv * k;
}

export default {
  name: 'IntroMap',
  inject: ['mq'],

  static: () => ({
    introMapSrc,
  }),

  methods: {
    onScroll (diff, { scrollTop, offsetHeight } = $scroll) {
      // this._scrollTop = scrollTop;
      const { cont } = this.$refs;
      this._visible = scrollTop < offsetHeight + 100;

      if (!this._visible && this._preventOverload)
        return;

      const erp = invlerp(0, offsetHeight, scrollTop) || 1e-12;

      const scale = (1 - Math.abs(erp))**1.6 || .01;
      let translate = erp * window.innerWidth / 1.5;
      if (this.mq.pointer.coarse)
        translate *= 3;
      const rotate = exp(erp, .8) * 90;
      // cont.style.display = erp ? '' : 'none';
      const transform = `perspective(${ 1000 - Math.abs(erp)**.7 * 800 }px)`
        + `scale(${ scale }) `
        + `rotateY(${ -rotate }deg) `
        + `translateX(${ translate }px) `
        // + `translateY(${ erp * 300 }px) `
        + `translateZ(${ exp(erp, .6) * 200 }px)`;

      cont.style.transform = transform;
      cont.style.opacity = (1 - Math.abs(erp))**3;
    },

    onPointerMove (e) {
      const { img } = this.$refs;

      // calibrate again
      if (!this._visible && this._preventOverload) {
        this._pointerTrans = -1;
        img.style.transition = '';
        return;
      }

      const { pageX: pox, pageY: poy } = e;
      // poy += this._scrollTop || $scroll.scrollTop;
      const { /*x, width,*/ y, height } = img.getBoundingClientRect();
      const c = {
        x: window.innerWidth,
        y: y + height / 2,
      };

      // clear transition after first calibration
      if (this._pointerTrans !== true) {
        clearTimeout(this._pointerTrans);
        this._pointerTrans = setTimeout(() => {
          img.style.transition = 'all 0s';
          this._pointerTrans = true;
        }, 200);
      }

      const rel = {
        x: (c.x - pox) / window.innerWidth,
        y: (c.y - poy) / window.innerHeight,
      };

      img.style.transform = 'perspective(500px) translateZ(0px) '
        + `translateX(${ rel.x*30 }px) translateY(${ rel.y*30 }px) `
        + `rotateX(${ rel.y*5 }deg) `
        + `rotateY(${ -rel.x*12 }deg)`;
    },

    // initGravity () {
    //   window.ondevicemotion = function(event) {
    //     console.log('IntroMap.vue', event.accelerationIncludingGravity);
    //     ax = Math.round(Math.abs(event.accelerationIncludingGravity.x * 1));
    //     ay = Math.round(Math.abs(event.accelerationIncludingGravity.y * 1));
    //     az = Math.round(Math.abs(event.accelerationIncludingGravity.z * 1));
    //     ai = Math.round(event.interval * 100) / 100;
    //     rR = event.rotationRate;
    //     if (rR != null) {
    //       arAlpha = Math.round(rR.alpha);
    //       arBeta = Math.round(rR.beta);
    //       arGamma = Math.round(rR.gamma);
    //     }
    //     this.$refs.grav = `${ arAlpha } :: ${ arBeta } :: ${ arGamma }`
    //   }
    // },
  },

  mounted () {
    // this.initGravity();
    this._pointerTrans = -1;
    this.offMapOnScroll = onScroll(this.onScroll);
    if (this.mq.pointer.fine)
      window.addEventListener('pointermove', this.onPointerMove);
    setTimeout(() => { this._preventOverload = true }, 2000);
  },

  unmounted () {
    this.offMapOnScroll?.();
    window.removeEventListener('pointermove', this.onPointerMove);
  },
};

</script>
<style>
.IntroMap {
  position: fixed;
  z-index: calc(var(--zi-topb) - 1);

  opacity: 0;

  pointer-events: none;
  will-change: transform, opacity;
}

.IntroMap__img {
  position: relative;

  width: 100%;
  height: 100%;

  object-fit: contain;

  opacity: .7;

  transition: transform .2s;

  will-change: transform, opacity;
}

.IntroMap__scale-lfo {
  width: 100%;
  height: 100%;

  --k-scale-lfo-from: 1.01;
  --k-scale-lfo-to: .99;
  animation: k-scale-lfo 4s infinite ease-in-out both;
}

/* LG */
@media (min-width: 740px) {
  .IntroMap {
    top: calc(var(--topb-h) + (100vh / 2));
    right: 50px;

    width: 60vw;
    --h: calc(100vh - var(--topb-h) * .8);
    height: var(--h);
    margin-top: calc(var(--h) / -2 - var(--topb-h) / 2);
  }
}

/* SM */
@media (max-width: 739px) {
  .IntroMap {
    bottom: 5vh;

    width: 120vw;
    margin-left: auto;
  }
}
</style>
